/*
 * File: /src/router/routes/whatsappTemplates.js
 * Created Date: Saturday November 14th 2020
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 14th November 2020 8:55:51 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2020 AdBase, Inc.
 */

const WhatsappTemplateList = () =>
  import(/* webpackChunkName: "WhatsappTemplateList" */ 'src/components/Dashboard/Views/WhatsappTemplates/WhatsappTemplateList.vue');

const WhatsappTemplateEdit = () =>
  import(/* webpackChunkName: "WhatsappTemplateEdit" */ 'src/components/Dashboard/Views/WhatsappTemplates/WhatsappTemplateEdit.vue');
export const whatsappTemplateRoutes = [
  {
    path: 'whatsapp-templates/add',
    name: 'Add Whatsapp Template',
    component: WhatsappTemplateEdit,
  },
  {
    path: 'whatsapp-templates/edit/:id',
    name: 'Edit Whatsapp Template',
    component: WhatsappTemplateEdit,
  },
  {
    path: 'whatsapp-templates/list',
    name: 'List Whatsapp Templates',
    component: WhatsappTemplateList
  }
];
